<template>
    <div class="msg-center">
		<Loading v-if="!loadingDone"/>
        <div class="msg-ctrl">
            <div class="msg-ctrl-box">
                <div class="del-all" @click="delAllMsg"><span></span>全部删除</div>
                <div class="all-to-read" @click="allMsgRead"><span></span>全部已读</div>
            </div>
        </div>
        <div class="msg-box">
            <van-list
            v-model="loading"
            :finished="finished"
            finished-text="没有更多啦~"
            :error.sync="error"
            error-text="请求失败  点击重新加载"
            @load="onMsgLoad"
            :offset=100
            :immediate-check="false"
            >
				<!-- 当消息为空时显示 -->
				<div class="empty" v-if="msgArr.length==0"><img src="../assets/img/empty.png" alt=""></div>
                <van-swipe-cell v-for="(item,index) in msgArr" :key="index">
					<router-link :to="{name:'msgdetail',query:{id:item&&item.id}}">
                    <div class="msg-content-box">
                        <div class="msg-icon">
                            <img :src="item&&item.icon" alt="">
                            <span class="unread-tag" v-if="item&&item.status==0&&unReadTag"></span>
                        </div>
                        <div class="msg-content">
                            <div class="title-time">
                                <div class="title">{{item&&item.title}}</div>
                                <div class="time">{{item&&item.datetime}}</div>
                            </div>
                            <div class="content">{{item&&item.content}}</div>
                        </div>
                    </div>
					</router-link>
                    <van-button
                        slot="right"
                        square
                        text="删除"
                        type="danger"
                        class="delete-button"
                        @click="delMsg"
                        :data-role="item&&item.id"                        
                    />
                </van-swipe-cell>
            </van-list>
        </div>
    </div>
</template>

<script>
import Loading from '@/components/Loading'
import {Axios} from '@/assets/api/axios'
import notifyIcon from '@/assets/img/msgicon.png'
export default {
    name: 'MsgCenter',
    data(){
        return{
            msgArr:[],                       //储存消息
            pageNum:0,                       //加载更多页码控制
            loading: false,                  //控制上划加载状态显示
            finished: false,                 //控制上划加载完成状态显示
			error: false,                    //控制上划加载出错状态显示
			unReadTag:true,                  //控制未读小红点显示隐藏
			loadingDone:false,               //控制消息加载页面显示隐藏
			allMsgCount:''                   //消息总数量
        }
    },
    created(){
        Axios.get('/user/message',{params:{page:this.pageNum,num:10}})
        .then(
            response=>{
                if(response.data.code==200&&response.data.status=="success"){
					this.msgArr=response.data.data.lists
					this.allMsgCount=response.data.data.all_count
					this.loadingDone=true
                }
            }
        ).catch(
            error=>{
                console.log(error)
            }
        )
    },
    methods:{
        //滑屏时加载更多消息
        onMsgLoad(){
            this.pageNum++
            Axios.get('/user/message',{params:{page:this.pageNum,num:10}})
            .then(
                response=>{
                    if(response.data.code==200&&response.data.status=="success"){
                        if(response.data.data.lists.length==0){
                            this.finished=true
                            return false
                        }
                        this.msgArr.push(...response.data.data.lists)
                        this.loading=false
                    }
                }
            ).catch(
                error=>{
                    this.loading=false
                    this.error=true
                    console.log(error)
                }
            )
        },
        //删除消息
        delMsg(e){
            Axios.get('/user/message/delete',{params:{message_id:e.target.dataset.role}})
            .then(
                response=>{
					if(response.data.code==200&&response.data.status=="success"){
						//删除成功后删除当前DOM节点
						e.target.parentNode.parentNode.parentNode.remove()
						//如果消息未加载完调用滚动加载方法
						if(this.finished!==true&&this.allMsgCount>10){
							this.onMsgLoad()
						}
					}else if(response.data.code==200&&response.data.status=="error"){
						this.$swal({
							text:'未读消息不能删除',
							showConfirmButton:false,
							width:'6rem',
							padding:'0.5rem',
							timer:1200,
							imageWidth:50,
							imageHeight:50,
							imageUrl:notifyIcon,
							timerProgressBar: true
						});
					}
                }
            ).catch(
                error=>{
                    this.$swal({
						text:'网络错误 请稍后重试',
						showConfirmButton:false,
						width:'6rem',
						padding:'0.5rem',
						timer:1200,
						imageWidth:50,
						imageHeight:50,
						imageUrl:notifyIcon,
						timerProgressBar: true
					});
                }
            )
		},
		//设置消息全部已读
		allMsgRead(){
			Axios.get('/user/message/change/all').then(
				response=>{
					if(response.data.code==200&&response.data.status=="success"){
						this.unReadTag=false
					}
				}
			).catch(
				error=>{
					this.$swal({
						text:'网络错误 请稍后重试',
						showConfirmButton:false,
						width:'6rem',
						padding:'0.5rem',
						timer:1200,
						imageWidth:50,
						imageHeight:50,
						imageUrl:notifyIcon,
						timerProgressBar: true
					});
				}
			)
		},
		//删除全部消息
		delAllMsg(){
			Axios.get('/user/message/delete',{params:{all:1}}).then(
				response=>{
					if(response.data.code==200&&response.data.status=="success"){
						Axios.get('/user/message',{params:{page:this.pageNum,num:10}})
						.then(
							response=>{
								if(response.data.code==200&&response.data.status=="success"){
									this.msgArr=response.data.data.lists
								}
							}
						).catch(
							error=>{
								console.log(error)
							}
						)
					}else if(response.data.code==200&&response.data.status=="error"){
						this.$swal({
							text:'未读消息不能删除',
							showConfirmButton:false,
							width:'6rem',
							padding:'0.5rem',
							timer:1200,
							imageWidth:50,
							imageHeight:50,
							imageUrl:notifyIcon,
							timerProgressBar: true
						});
					}
				}
			).catch(
				error=>{
					this.$swal({
						text:'网络错误 请稍后重试',
						showConfirmButton:false,
						width:'6rem',
						padding:'0.5rem',
						timer:1200,
						imageWidth:50,
						imageHeight:50,
						imageUrl:notifyIcon,
						timerProgressBar: true
					});
				}
			)
		}
    },
    components:{
        Loading
    }
}
</script>

<style scoped lang="scss">
	.empty{
		background:#fff;
		height:280px;
		padding-top:200px;
		img{
			width:280px;
			height:280px;
			display:block;
			margin:0 auto;
		}
	}
    .msg-center{
        width:750px;
        padding-top:88px;
        background:#F8F6F9;
    }
    .msg-ctrl{
        height:80px;
        margin-bottom:10px;
        .msg-ctrl-box{
            padding:29px 44px;
            height:22px;
            background:#fff;
            .del-all,.all-to-read{
                float:right;
                font-size:24px;
                color:#222;
                margin-left:50px;
                span{
                    display:inline-block;
                    margin-right:10px;
                }
            }
            .del-all{
                span{
                    width:23px;
                    height:23px;
                    background:url('../assets/img/delmsg.png') no-repeat;
                    background-size:cover;
                }
            }
            .all-to-read{
                span{
                    width:23px;
                    height:18px;
                    background:url('../assets/img/readmsg.png') no-repeat;
                    background-size:cover;
                }
            }
        }
    }
    .msg-box{
        .van-swipe-cell{
            min-height:188px;
			padding-bottom:20px;
            background:#fff;
            margin-bottom:10px;
        }
        .van-swipe-cell__right{
            min-height:208px;
            width:80px;
            button{
                min-height:208px;
                word-break:break-all;
                font-size:24px;
                width:60px;
            }
        }
        .msg-content-box{
            padding:40px;
            .msg-icon{
                width:60px;
                height:60px;
                position:relative;
                float:left;
                margin-right:20px;
                img{
                    width:100%;
                    height:100%;
                }
                .unread-tag{
                    width:10px;
                    height:10px;
                    background:#bf0000;
                    border-radius:50%;
                    position:absolute;
                    right:10px;
                    top:0px;
                }
            }
            .msg-content{
                width:580px;
                float:left;
                .title-time{
                    height:30px;
                    margin-bottom:26px;
                    .title{
                        font-size:26px;
                        color:#333;
                        float:left;
                        font-weight:bold;
                    }
                    .time{
                        font-size:22px;
                        color:#999;
                        float:right;
                    }
                }
                .content{
                    font-size:22px;
                    color:#333;
					overflow:hidden;
					text-overflow:ellipsis;
					display:-webkit-box;
					-webkit-box-orient:vertical;
					-webkit-line-clamp:3;
					line-height:30px;
                }
            }
        }
    }
</style>
